import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { FilterService } from './../../services/filter.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit, OnDestroy {
  private readonly onDestroy = new Subject<void>();
  filters;
  materials;
  showOrder: boolean;
  filterNavigation: boolean;
  @Input() material$;
  @Input() orderByLabel;
  @Input() results;
  @Input() breadcrumb;
  @Output() orderBy = new EventEmitter();
  @Output() filterResult = new EventEmitter();

  constructor(private _filter: FilterService) { }

  ngOnInit() {
    this.showOrder = false;
    this.filterNavigation = false;
    this.material$.pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.filters = this._filter.setFilter(data);
      });
  }

  orderByOptions(label, field, direction) {
    this.orderBy.emit({'label':label, 'field':field, 'direction':direction});
  }

  filterBySelection(grupo,item) {
    let obj = this.filters.find(obj => obj.name == grupo);
    if (obj.selected.includes(item)) {
      obj.selected = obj.selected.filter(prop => prop !== item);
    } else {
      obj.selected.push(item);
    }
    this.filterResult.emit(this.filters);
  }

  clearFilter() {
    this.filters.forEach(function(item) {
      item.selected = [];
    });
    this.filterResult.emit(this.filters);
  }

  ngOnDestroy() {
    this.onDestroy.next();
  }

}
